/* src/app/main/performance/wizard/steps/column-mapping/performance-column-selection.component.scss */
.column-mapping-row {
  margin-bottom: 1rem;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 0.5rem;
}
.input-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 0.5rem;
}
.input-group label {
  min-width: 180px;
  font-weight: bold;
}
.input-group select,
.input-group input[type=text] {
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  width: 260px;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}
.input-group select:hover,
.input-group select:focus,
.input-group input[type=text]:hover,
.input-group input[type=text]:focus {
  border-color: #006f8a;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  outline: none;
}
.toggle-advanced {
  font-size: 0.9rem;
  color: #007bff;
  cursor: pointer;
  display: inline-block;
  margin-top: 4px;
}
.advanced-options {
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}
.input-group-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
/*# sourceMappingURL=performance-column-selection.component-2ADG37AJ.css.map */
